import {
  RELEASE_SWITCH_TOGGLE,
  RELEASE_TOGGLE_MARKETPLACE,
  RELEASE_TOGGLE_SAE_ONLY
} from 'shared/experiments/consts'
import { FeatureFlagCookie } from 'views/utils/experiments/types'

interface ExperimentOptions {
  experimentName: string
  featureFlagCookie: FeatureFlagCookie
  variable: string
}

// TODO find out why the names are duplicated in `app/shared/experiments/utils/index.ts`
export function isExperimentVariableTrue(params: ExperimentOptions): boolean {
  const { experimentName, featureFlagCookie, variable } = params

  const experiment = featureFlagCookie?.[experimentName]

  if (!experiment?.e) {
    return false
  }

  return experiment.v?.[variable] === true
}

/**
 * Determines if SAE is enabled. Usage only applicable on controller level
 * @param featureFlagCookie Accepts feature flag cookie
 */
export const isSaeOnly = (featureFlagCookie: FeatureFlagCookie): boolean =>
  isExperimentVariableTrue({
    experimentName: RELEASE_SWITCH_TOGGLE,
    featureFlagCookie,
    variable: RELEASE_TOGGLE_SAE_ONLY
  })

export const isMarketplace = (featureFlagCookie: FeatureFlagCookie): boolean =>
  isExperimentVariableTrue({
    experimentName: RELEASE_SWITCH_TOGGLE,
    featureFlagCookie,
    variable: RELEASE_TOGGLE_MARKETPLACE
  })
